import { citySchema } from "@/features/dashboard/types/city";
import { provinceSchema } from "@/features/dashboard/types/province";
import { regionSchema } from "@/features/dashboard/types/region";
import { userSchema } from "@/features/dashboard/types/user";
import { z } from "zod";

export const defendantSchema = z.object({
	id: z.string(),
	first_name: z.string(),
	last_name: z.string(),
	middle_name: z.string().optional(),
	email: z.string().optional(),
	classification: z.string(),
	role: z.string().optional(),
	corporation: z.string().optional(),
	landline: z.string().optional().nullable(),
	region: regionSchema,
	province: provinceSchema,
	city: citySchema,
	user: userSchema.optional(),
	barangay: z.string().min(1, { message: "Required" }),
	address_1: z.string().min(1, { message: "Required" }),
	address_2: z.string().optional(),
	region_code: z.string().min(1, { message: "Required" }),
	province_code: z.string().min(1, { message: "Required" }),
	city_code: z.string().min(1, { message: "Required" }),
	mobile_number: z.string().optional(),
	zipcode: z.union([z.string(), z.number()]).nullable().optional(),
});

export const defendantFormSchema = z
	.object({
		suffix: z.string().nullable().optional(),
		first_name: z.string().optional(),
		last_name: z.string().optional(),
		address_type: z.string().optional(),
		middle_name: z.string().nullable().optional(),
		defendant_id: z.string().nullable().optional(),
		country: z.string().nullable().optional(),
		representatives: z
			.array(
				z.object({
					id: z.string().optional(),
					name: z.string().nullable().optional(),
					address: z.string().nullable().optional(),
					email: z
						.union([z.string().email(), z.literal(""), z.null()])
						.optional()
						.nullable(),
				}),
			)
			.optional(),
		email: z
			.union([z.string().email(), z.literal(""), z.null()])
			.optional()
			.nullable(),
		mobile_number: z.string().nullable().optional(),
		landline: z.string().optional().nullable(),
		classification: z.string().nullable().optional(),
		corporation: z.string().optional().nullable(),
		barangay: z.string().nullable().optional(),
		address_1: z.string().min(1, { message: "Required" }),
		address_2: z.string().nullable().optional(),
		region_code: z.string().nullable().optional(),
		province_code: z.string().nullable().optional(),
		city_code: z.string().nullable().optional(),
		zipcode: z.union([z.string(), z.number()]).nullable().optional(),
		// zipcode: z
		// 	.union([z.string(), z.number()])
		// 	.transform((val) => String(val))
		// 	.refine((val) => /^\d{4}$/.test(val), {
		// 		message: "Zipcode must be a 4-digit number",
		// 	}),
		region: regionSchema.optional().nullable(),
		province: provinceSchema.optional().nullable(),
		city: citySchema.optional().nullable(),
		use_existing_party: z.any(),
		party_id: z.any().optional().nullable(),
	})
	.superRefine((data, ctx) => {
		if (data.classification !== "Individual") {
			if (!data.corporation || data.corporation?.trim() === "") {
				ctx.addIssue({
					path: ["corporation"],
					code: z.ZodIssueCode.custom,
					message: "Name is Required",
				});
			}
		}
		if (data.classification === "Individual") {
			if (!data.first_name || data.first_name?.trim() === "") {
				console.log("tes");
				ctx.addIssue({
					path: ["first_name"],
					code: z.ZodIssueCode.custom,
					message: "First Name is Required",
				});
			}

			if (!data.last_name || data.last_name?.trim() === "") {
				ctx.addIssue({
					path: ["last_name"],
					code: z.ZodIssueCode.custom,
					message: "Required",
				});
			}
		}
		if (data.address_type === "domestic") {
			if (!data.barangay) {
				ctx.addIssue({
					path: ["barangay"],
					code: z.ZodIssueCode.custom,
					message: "Required",
				});
			}
			if (!data.region_code) {
				ctx.addIssue({
					path: ["region_code"],
					code: z.ZodIssueCode.custom,
					message: "Required",
				});
			}
			if (!data.province_code) {
				ctx.addIssue({
					path: ["province_code"],
					code: z.ZodIssueCode.custom,
					message: "Required",
				});
			}
			if (!data.city_code) {
				ctx.addIssue({
					path: ["city_code"],
					code: z.ZodIssueCode.custom,
					message: "Required",
				});
			}
		}
	});

export type Defendant = z.infer<typeof defendantSchema>;
export type DefendantFormSchema = z.infer<typeof defendantFormSchema>;
